import React, { createContext, useContext, useMemo } from "react";

import { getTemplate } from "../templates/registry";

import { TemplateContextType, TemplateProviderProps } from "@/types/template";

const TemplateContext = createContext<TemplateContextType>({
  templateId: "default",
  templateName: "Classic Receipt",
});

export const TemplateProvider: React.FC<TemplateProviderProps> = ({
  templateId,
  children,
}) => {
  const template = getTemplate(templateId);

  const contextValue = useMemo(
    () => ({
      templateId,
      templateName: template.name,
    }),
    [templateId, template.name]
  );

  return (
    <TemplateContext.Provider value={contextValue}>
      {children}
    </TemplateContext.Provider>
  );
};

export const useTemplate = () => useContext(TemplateContext);
